export default __webpack_public_path__ + "static/media/icon-condensation-temperature-compressor.af8dc3a3.svg";